var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmlActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19669_5478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4.1665L15 5.83317L18.3333 2.49984M18.3333 9.99984V14.3332C18.3333 15.7333 18.3333 16.4334 18.0608 16.9681C17.8212 17.4386 17.4387 17.821 16.9683 18.0607C16.4335 18.3332 15.7335 18.3332 14.3333 18.3332H5.66666C4.26653 18.3332 3.56646 18.3332 3.03168 18.0607C2.56128 17.821 2.17882 17.4386 1.93914 16.9681C1.66666 16.4334 1.66666 15.7333 1.66666 14.3332V5.6665C1.66666 4.26637 1.66666 3.56631 1.93914 3.03153C2.17882 2.56112 2.56128 2.17867 3.03168 1.93899C3.56646 1.6665 4.26653 1.6665 5.66666 1.6665H9.99999M1.78791 16.6051C2.17887 15.1987 3.46879 14.1665 4.9998 14.1665H10.8331C11.6076 14.1665 11.9948 14.1665 12.3168 14.2306C13.6391 14.4936 14.6727 15.5272 14.9357 16.8495C14.9998 17.1715 14.9998 17.5587 14.9998 18.3332M11.6667 7.9165C11.6667 9.75745 10.1743 11.2498 8.33332 11.2498C6.49237 11.2498 4.99999 9.75745 4.99999 7.9165C4.99999 6.07555 6.49237 4.58317 8.33332 4.58317C10.1743 4.58317 11.6667 6.07555 11.6667 7.9165Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19669_5478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmlActive);
export default __webpack_public_path__ + "static/media/AMLActive.d884a88f5fdaec660f11f4e063850630.svg";
export { ForwardRef as ReactComponent };